import * as React from 'react';
import { Box, Stack } from '@resi-media/resi-ui';
import { useLocation } from 'react-router';
import type { SWRResponse } from 'swr';
import { VideoFetch } from '@sites/components/VideoFetch';
import { LAYOUT_CONTAINER_ID, HEADER_PADDING_X, MOBILE_HEADER_PADDING_X } from '@sites/constants/layout';
import { useLivePlayer } from '@sites/contexts/livePlayerContext';
import { useQueryParams } from '@sites/contexts/queryContext';
import type CustomError from '@sites/helpers/customError';
import type { Videos } from '@sites/types';
import { LivePlayerBanner } from '../LivePlayerBanner';

type _Props = {
  children: (values: SWRResponse<Videos.Get.Video, CustomError>) => React.ReactNode;
};

const VideoPageContainer = ({ children }: _Props) => {
  const { isEmbed } = useQueryParams();
  const { pathname } = useLocation();
  const { showBanner } = useLivePlayer();

  React.useEffect(() => {
    const container = document.getElementById(LAYOUT_CONTAINER_ID);
    if (container) {
      container.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname]);

  return (
    <Box dataTestId="video-page-container" mb="m" mt={isEmbed ? 'x20' : 'xl'}>
      <Stack gap="l">
        {showBanner && (
          <Box gap="l" px={{ xs: MOBILE_HEADER_PADDING_X, lg: HEADER_PADDING_X }} py={0}>
            <LivePlayerBanner />
          </Box>
        )}
        <VideoFetch>{(data) => children(data)}</VideoFetch>
      </Stack>
    </Box>
  );
};

VideoPageContainer.displayName = 'VideoPageContainer';

export default VideoPageContainer;
